var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 3.37512H2.8125C2.66332 3.37512 2.52024 3.43439 2.41475 3.53987C2.30926 3.64536 2.25 3.78844 2.25 3.93762C2.25 4.08681 2.30926 4.22988 2.41475 4.33537C2.52024 4.44086 2.66332 4.50012 2.8125 4.50012H3.375V14.6251C3.375 14.9235 3.49353 15.2096 3.7045 15.4206C3.91548 15.6316 4.20163 15.7501 4.5 15.7501H13.5C13.7984 15.7501 14.0845 15.6316 14.2955 15.4206C14.5065 15.2096 14.625 14.9235 14.625 14.6251V4.50012H15.1875C15.3367 4.50012 15.4798 4.44086 15.5852 4.33537C15.6907 4.22988 15.75 4.08681 15.75 3.93762C15.75 3.78844 15.6907 3.64536 15.5852 3.53987C15.4798 3.43439 15.3367 3.37512 15.1875 3.37512ZM13.5 14.6251H4.5V4.50012H13.5V14.6251ZM5.625 1.68762C5.625 1.53844 5.68426 1.39536 5.78975 1.28987C5.89524 1.18439 6.03832 1.12512 6.1875 1.12512H11.8125C11.9617 1.12512 12.1048 1.18439 12.2102 1.28987C12.3157 1.39536 12.375 1.53844 12.375 1.68762C12.375 1.83681 12.3157 1.97988 12.2102 2.08537C12.1048 2.19086 11.9617 2.25012 11.8125 2.25012H6.1875C6.03832 2.25012 5.89524 2.19086 5.78975 2.08537C5.68426 1.97988 5.625 1.83681 5.625 1.68762Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fe4ad9cb5bcc4dd33412fa017c87063d.svg";
export { ForwardRef as ReactComponent };